let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2BwB1")).then(() => parcelRequire('btRta'));